import sync, { cancelSync } from 'framesync';
function delay(callback, timeout) {
  var start = performance.now();
  var checkElapsed = function checkElapsed(_ref) {
    var timestamp = _ref.timestamp;
    var elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelSync.read(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  sync.read(checkElapsed, true);
  return function () {
    return cancelSync.read(checkElapsed);
  };
}
export { delay };